import { render, staticRenderFns } from "./timeStatus.vue?vue&type=template&id=5254b374&scoped=true"
import script from "./timeStatus.vue?vue&type=script&lang=js"
export * from "./timeStatus.vue?vue&type=script&lang=js"
import style0 from "./timeStatus.vue?vue&type=style&index=0&id=5254b374&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!D:\\work\\dys\\duyisheng-admin-ui\\node_modules\\vue-loader\\lib\\runtime\\componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5254b374",
  null
  
)

export default component.exports